export const accordion = {
  root: {
    transitionDuration: "{transition.duration}",
  },
  panel: {
    borderWidth: "0 0 1px 0",
    borderColor: "{content.border.color}",
  },
  header: {
    color: "{typography.accordion.heading.color}",
    hoverColor: "{typography.accordion.heading.color}",
    activeColor: "{typography.accordion.heading.color}",
    padding: "{padding.12} {padding.16}",
    fontWeight: "{typography.accordion.heading.font.weight}",
    borderRadius: "0",
    borderWidth: "0",
    borderColor: "{content.border.color}",
    background: "{content.background}",
    hoverBackground: "{content.background}",
    activeBackground: "{content.background}",
    activeHoverBackground: "{content.background}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}",
    },
    toggleIcon: {
      color: "{color.gray.500}",
      hoverColor: "{color.gray.400}",
      activeColor: "{color.gray.500}",
      activeHoverColor: "{color.gray.400}",
    },
    first: {
      topBorderRadius: "{content.border.radius}",
      borderWidth: "0",
    },
    last: {
      bottomBorderRadius: "{content.border.radius}",
      activeBottomBorderRadius: "0",
    },
  },
  content: {
    borderWidth: "0",
    borderColor: "{content.border.color}",
    background: "{content.background}",
    color: "{content.color}",
    padding: "0 {padding.16} {padding.32} {padding.16}",
  },
  extend: {
    ui: {
      panel: {
        last: {
          borderWidth: "0",
        },
      },
      header: {
        fontSize: "{typography.accordion.heading.font.size}",
        fontLeading: "{typography.accordion.heading.font.leading}",
        toggleIcon: {
          width: "{button.icon.only.width}",
        },
      },
    },
  },
  css: ({ dt }: any): string => `
    .p-accordionpanel:last-child {
      border-width: ${dt("accordion.ui.panel.last.border.width")};
    }

    .p-accordionheader {
      font-size: ${dt("accordion.ui.header.font.size")};
      line-height: ${dt("accordion.ui.header.font.leading")};
    }

    .p-accordionheader > span.pi {
      width: ${dt("accordion.ui.header.toggle.icon.width")};
      text-align: center;
    }
  `,
};
